import { render, staticRenderFns } from "./LinhaDeDadosResumo.vue?vue&type=template&id=1a02ff1c&scoped=true"
import script from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeDadosResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeDadosResumo.vue?vue&type=style&index=0&id=1a02ff1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02ff1c",
  null
  
)

export default component.exports